import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import useSheetsDb from './useSheetsDb';

const useAllSheetInformationIdsInBook = (bookId: string): string[] => {
  const sheetInformationDb = useSelector((state: RootState) => state.sheetInformationDb);
  const [sheetIds] = useSheetsDb(bookId);
  const ids: string[] = [];
  sheetIds.forEach(sheetId => {
    const nominateIds = Object.keys(sheetInformationDb.sheetInformations).filter(id => sheetInformationDb.sheetInformations[id].sheetId === sheetId);
    ids.push(...nominateIds);
  })

  return ids;
}

export default useAllSheetInformationIdsInBook;
